export default __webpack_public_path__ + "static/media/nada.ffdad94d.svg";